import { handleActions } from 'redux-actions';
import reducersUtils from 'state/utils';
import actions from 'state/direct-order-recurring/quote/actionCreators';
import initialState from 'state/direct-order-recurring/quote/initial.state';

const quote = handleActions(
  {
    [reducersUtils.RESET_ORDER_STATE]: () => initialState,
    [actions.setQuote]: (state, { payload: { quote: quoteResponse } }) => ({
      ...state,
      quote: { ...quoteResponse },
      hasError: false,
    }),
    [actions.cleanQuote]: (state) => ({
      ...state,
      quote: {},
      hasError: false,
    }),
    [actions.setQuoteError]: (state, { payload: { errorType } }) => ({
      ...state,
      hasError: true,
      errorType,
    }),
    [actions.cleanQuoteError]: (state) => ({
      ...state,
      hasError: false,
      errorType: '',
    }),
  },
  initialState
);

export default quote;
